import { createSelector } from 'reselect';
import { resolveProp } from '@clearscore-group/lib.helpers.resolve-props';

const getFailureReason = (state) => resolveProp('identity.failureReason', state);

export default createSelector(getFailureReason, (failureReason) => ({
    failureReason,
}));
